import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";

// Small form dialog used for links, image alt text and scheduling.
export const FieldDialog = ({ open, onClose, title, description, fields, submitLabel = "Save", onSubmit, testid = "field-dialog" }) => {
  const [values, setValues] = useState({});
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const val = (f) => values[f.key] ?? f.value ?? "";
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await onSubmit(Object.fromEntries(fields.map((f) => [f.key, val(f)])));
      setValues({});
      onClose();
    } catch (ex) { setErr(ex?.message || "Something went wrong"); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { setValues({}); setErr(""); onClose(); } }}>
      <DialogContent data-testid={testid}>
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          <div className="mt-4 space-y-3">
            {fields.map((f) => (
              <label key={f.key} className="block">
                <span className="text-xs font-bold uppercase tracking-widest text-[#581C87]">{f.label}</span>
                <input type={f.type || "text"} value={val(f)} placeholder={f.placeholder} autoFocus={f.autoFocus}
                  onChange={(e) => setValues((v) => ({ ...v, [f.key]: e.target.value }))}
                  className="mt-1 w-full rounded-xl border border-violet-200 px-3 py-2.5 text-sm" data-testid={`${testid}-${f.key}`} />
                {f.hint && <span className="mt-1 block text-xs text-slate-500">{f.hint}</span>}
              </label>
            ))}
            {err && <p className="text-sm font-semibold text-red-600" data-testid={`${testid}-error`}>{err}</p>}
          </div>
          <DialogFooter className="mt-6">
            <button type="button" onClick={onClose} className="rounded-full px-5 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-100">Cancel</button>
            <button disabled={busy} className="btn-accent" data-testid={`${testid}-submit`}>{submitLabel}</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
